import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { SearchStateParameters, StateClient, StateView } from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class StateService {
    constructor(private readonly client: StateClient) {}

    async search(body: SearchStateParameters): Promise<StateView[]> {
        return await lastValueFrom(this.client.stateSearch(body));
    }

    async getById(id: number): Promise<StateView> {
        return await lastValueFrom(this.client.stateGetById(id));
    }
}
